module.exports = __webpack_public_path__ + "static/media/roundClose-img.7f45ebe8.svg";